import { render, staticRenderFns } from "./CharityWill.vue?vue&type=template&id=ac3d7ac4"
import script from "./CharityWill.vue?vue&type=script&lang=js"
export * from "./CharityWill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports